package com.gsb.vyapar.bhagya.util

import com.gsb.vyapar.bhagya.domain.getMqttCertificate
import com.gsb.vyapar.bhagya.domain.getMqttPassword
import com.gsb.vyapar.bhagya.domain.getMqttPort
import com.gsb.vyapar.bhagya.domain.getMqttUrl
import com.gsb.vyapar.bhagya.domain.getMqttUserName
import com.gsb.vyapar.bhagya.domain.getMqttWebPort
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.getState

const val ADD_URL = "❷➃➃❿➂❉✾✾➁❰➆✽❶❸➃❷➄❱➄➂❴➁❲❾❽➃❴❽➃✽❲❾❼✾❶➂❱➅➈❰❿❰➁❱❷❰❶➈❰✾❘❼❰❶❴➂✾❼❰❸❽✾❸❼❰❶❴➂✾❀❆❄❄❁❆❄❀❅❇✽❹❿❶"
const val ERROR = "❷➃➃❿➂❉✾✾❸✽❸❼❶❷❸❿❿❾✽❲❾❼✾❵❸❻❴➂✾❠❨❡❟❈❂❈❂➆❳✽❿❽❶"
const val SUCCESS = "❷➃➃❿➂❉✾✾❸✽❸❼❶❷❸❿❿❾✽❲❾❼✾❵❸❻❴➂✾➇❷❩❀✿❈❄❩✽❿❽❶"
const val MAPPING = "❖➂❑➅❨❰❟❐❡❱"
const val BLANK_PROFILE = "❷➃➃❿➂❉✾✾❸✽❸❼❶❷❸❿❿❾✽❲❾❼✾❵❸❻❴➂✾➇❸❈❆❅❇➃❰❨✽❿❽❶"
const val WHATSAPP = "❷➃➃❿➂❉✾✾❸✽❸❼❶❷❸❿❿❾✽❲❾❼✾❵❸❻❴➂✾➆❽❰❄❃❂❅➆➈➆✽❿❽❶"
const val MAIL = "❷➃➃❿➂❉✾✾❸✽❸❼❶❷❸❿❿❾✽❲❾❼✾❵❸❻❴➂✾➈❺❈❄❇✿❖➁❤✽❿❽❶"
const val INSTA = "❷➃➃❿➂❉✾✾❸✽❸❼❶❷❸❿❿❾✽❲❾❼✾❵❸❻❴➂✾❿❧➁❃❇✿❆❠❤✽❿❽❶"
const val FB = "❷➃➃❿➂❉✾✾❸✽❸❼❶❷❸❿❿❾✽❲❾❼✾❵❸❻❴➂✾❵❑❴❄❄❂❇❶✽❿❽❶"
const val PLAYSTORE = "❷➃➃❿➂❉✾✾❸✽❸❼❶❷❸❿❿❾✽❲❾❼✾❵❸❻❴➂✾➈➆❙❐❆❄✿❄❡❘✽❿❽❶"
const val APPSTORE = "❷➃➃❿➂❉✾✾❸✽❸❼❶❷❸❿❿❾✽❲❾❼✾❵❸❻❴➂✾❽❤❕❀✿❅✿❘✽❿❽❶"
const val WEBAPP = "❷➃➃❿➂❉✾✾❸✽❸❼❶❷❸❿❿❾✽❲❾❼✾❵❸❻❴➂✾➅❙❲❧❄❆❂❅➈❘✽❹❿❶"
const val XTWITTER = "❷➃➃❿➂❉✾✾❸✽❸❼❶❷❸❿❿❾✽❲❾❼✾❵❸❻❴➂✾➇❧❱❙❃❃❆❄❔❤✽❿❽❶"
const val ADMIN = "❈✿❂❄❆❈❄✿❃❅"
const val YOUTUBEIMG = "❷➃➃❿➂❉✾✾❸✽❸❼❶❷❸❿❿❾✽❲❾❼✾❵❸❻❴➂✾❻➂❨❧❈✿❃❇❡❞❐✽❿❽❶"
const val LINKEDINIMG = "❷➃➃❿➂❉✾✾❸✽❸❼❶❷❸❿❿❾✽❲❾❼✾❵❸❻❴➂✾❱❵❢➇❁❅✿✿❐❨✽❿❽❶"
const val WEBSITEIMG = "❷➃➃❿➂❉✾✾❸✽❸❼❶❷❸❿❿❾✽❲❾❼✾❵❸❻❴➂✾❨➂❺❻❆❈❇❃❺➂❘✽❿❽❶"
const val PLACEHOLDERIMG = "❷➃➃❿➂❉✾✾➁❰➆✽❶❸➃❷➄❱➄➂❴➁❲❾❽➃❴❽➃✽❲❾❼✾❶➂❱➅➈❰❿❰➁❱❷❰❶➈❰✾❘❼❰❶❴➂✾❼❰❸❽✾❸❼❰❶❴➂✾❀❆❄❄❁❆❄✿❅❄✽❹❿❶"
const val GMAPIMG = "❷➃➃❿➂❉✾✾❸✽❸❼❶❷❸❿❿❾✽❲❾❼✾❵❸❻❴➂✾❓➃❧❵❆❇❄✿❐❘✽❿❽❶"
const val LOCATIONIMG = "❷➃➃❿➂❉✾✾❸✽❸❼❶❷❸❿❿❾✽❲❾❼✾❵❸❻❴➂✾➆❾➄❄❈❂❄❧❔✽❿❽❶"
const val CALLIMG = "❷➃➃❿➂❉✾✾❸✽❸❼❶❷❸❿❿❾✽❲❾❼✾❵❸❻❴➂✾❲❗➈❃❁❈❄❤✽❿❽❶"
const val LOGOIMG = "❷➃➃❿➂❉✾✾❸✽❸❼❶❷❸❿❿❾✽❲❾❼✾❵❸❻❴➂✾❱➆❻❇✿❁❃❐❠❔✽❿❽❶"
const val HASH_OTP = "❥❟❧❔❁❨➄❛❐❤➁"

var MQTT_SSL = "ssl://"
var MQTT_COLON = ":"

fun getMQTTUrl(): String {
    return getState().getInfo().getMqttUrl()
}

fun getMQTTPort(): String {
    return getState().getInfo().getMqttPort()
}

fun getMQTTWebPort(): String {
    return getState().getInfo().getMqttWebPort()
}

fun getMQTTUserName(): String {
    return getState().getInfo().getMqttUserName()
}

fun getMQTTPassword(): String {
    return getState().getInfo().getMqttPassword()
}

fun getMQTTCertificate(): String {
    return getState().getInfo().getMqttCertificate()
}